import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shareInfos:""
  },
  mutations: {
    setShareInfo(state,data){
      state.shareInfos = data
    }
  },
  actions: {
  },
  modules: {
  }
})
